/**
 * Read More Component
 *
 * This component add Read More / Read Less Button
 */

import { useState } from "react";


const ReadMore=({ limit, children })=>{

    const text = children;

    const [isReadMoreShown, setReadMoreShown] = useState(false)

    const toggleBtn = () => {

       setReadMoreShown(prevState => !prevState)

    }

    return(

       <div className="read-more">
          {isReadMoreShown ? text : text.substr(0,limit)}
          <button className="btn-readmore" onClick={toggleBtn}> {(isReadMoreShown) ? <p>&nbsp;Read Less</p> : <p><span>...</span> Read More</p>}</button>
       </div>

    )
}

export default ReadMore;